import libericaIC from "src/images/pages/cloud-native-platform/liberica.svg"
import nikIC from "src/images/pages/cloud-native-platform/liberica-nik.svg"
import bellsoftIC from "src/images/pages/cloud-native-platform/bellsoft.svg"
import linuxIC from "src/images/pages/cloud-native-platform/linux.svg"

import * as React from "react"

export const products = [
    {
        title: 'Alpaquita Linux',
        background: '#1D223B',
        description: 'Alpaquita Linux is the only Linux optimized to run Java services. With optimized musl and glibc support, multiple kernel enhancements, userspace based on Alpine Linux aports, it is the convenient, secure, and robust Cloud solution.',
        button: {
          caption: 'Learn more',
          href: '/alpaquita-linux/'
        },
        image: linuxIC,
        childrenClassNames: {
            title: 'color-white',
            button: 'button-filled bg-white color-dark',
          },
        gridColumn: '1/5'
    },
    {
        title: 'Liberica JDK Lite',
        background: '#FFFFFF',
        description: 'The smallest and most performant instance of Liberica JDK. It is optimized for Cloud environment, bringing additional benefits in security, performance and memory consumption.',
        button: {
          caption: 'Learn more',
          href: '/libericajdk/'
        },
        icon: libericaIC,
        gridColumn: '5/7',
        childrenClassNames: {
          button: 'button-bordered',
        }
  },
    {
        title: 'Liberica Native Image Kit',
        background: '#FFFFFF',
        description: 'Alpaquita Linux fully supports and takes advantage of all BellSoft products, such as Liberica JDK, Liberica NIK, and Alpaquita container images.',
        icon: nikIC,
        button: {
            caption: 'Learn more',
            href: '/liberica-native-image-kit/'
        },
        gridColumn: '1/4',
        childrenClassNames: {
            button: 'button-bordered',
        }
    },
    {
        title: 'BellSoft support',
        background: '#FFFFFF',
        description: 'The engineers that built Alpaquita and helped to create modern Java will provide you with the prompt and professional support. Don\'t waste time talking to the men-in-the-middle, get help from the best in industry!',
        button: {
            caption: 'Learn more',
            href: '/support/'
        },
        image: bellsoftIC,
        gridColumn: '4/7',
        childrenClassNames: {
            button: 'button-bordered',
        }
    },

]
